import { render, staticRenderFns } from "./DormFloorGrid.vue?vue&type=template&id=35b19cb6&scoped=true"
import script from "./DormFloorGrid.vue?vue&type=script&lang=js"
export * from "./DormFloorGrid.vue?vue&type=script&lang=js"
import style0 from "./DormFloorGrid.vue?vue&type=style&index=0&id=35b19cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b19cb6",
  null
  
)

export default component.exports